import { Infer, array, enums, is, object, optional, string } from 'superstruct';

import { useFeatureServices } from './use-feature-services';

// Title schema
const SpecialOffersTitle = optional(
  array(
    object({
      title: optional(string()),
      fontSizeLarge: optional(string()), // example: "14", "12"
      fontSizeMedium: optional(string()),
      fontSizeSmall: optional(string()),
    }),
  ),
);

const SpecialOffersContent = optional(
  array(
    object({
      aprValue: optional(string()),
      showOfferType: optional(string()),
      financeTermLength: optional(string()),
      leaseTermLength: optional(string()),
      offerHighlight: optional(string()),
      offerId: string(),
      offerImage: optional(string()),
      offerImageDisclaimer: string(),
    }),
  ),
);

const Content = object({
  bodyType: optional(string()),
  enableIndirectShowroomTrims: optional(enums(['true', 'false', ''])),
  featureAppFeatureFlags: optional(
    array(object({ featureAppName: string(), featureFlags: string() })),
  ),
  featureFlags: optional(string()),
  sales_event_logo_url_dark: optional(string()),
  sales_event_logo_url_light: optional(string()),
  special_offers: SpecialOffersContent,
  special_offers_home_title: SpecialOffersTitle,
  special_offers_mlp_title: SpecialOffersTitle,
});

export type FeatureAppContent = Infer<typeof Content>;

export function useFeatureAppContent(): FeatureAppContent {
  const { 'fa-content-service': contentService } = useFeatureServices();
  const content = contentService?.content;

  return is(content, Content)
    ? content
    : {
        sales_event_logo_url_dark: '',
        sales_event_logo_url_light: '',
        special_offers: [],
        special_offers_home_title: [],
        special_offers_mlp_title: [],
      };
}
